export default __webpack_public_path__ + "static/media/Metrô.ecc6bc22.svg";